import React from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import { Controller } from 'react-hook-form';
import { FormHelperText, Box, Chip, MenuItem } from '@mui/material';

const MultiSelect = ({
  name,
  label,
  control,
  defaultValue,
  helperText,
  listValues,
  children,
  ...props
}) => {
  const labelId = `${name}-label`;

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue || []}
      render={({ field: { onChange, onBlur, value } }) => (
        <FormControl sx={{ mt: 2, mb: 0.5 }} fullWidth size="small" {...props}>
          <InputLabel id={labelId}>{label}</InputLabel>
          <Select
            labelId={labelId}
            label={label}
            multiple
            onChange={onChange}
            onBlur={onBlur}
            value={value || []}
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }} maxWidth="450px">
                {selected.map((val) => (
                  <Chip
                    key={val}
                    label={listValues.find((item) => item.id === val)?.name}
                    size="small"
                    color="primary"
                  />
                ))}
              </Box>
            )}>
            {children}
          </Select>
          {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
      )}
    />
  );
};

export default MultiSelect;
